import { Image } from '@wistia/vhs';
import type { CSSProperties, JSX } from 'react';

// TODO: Refactor Tooltip to accept image prop as string.
// https://app.shortcut.com/wistia-pde/story/31111/allow-tooltip-components-to-accept-image-prop-as-a-string
export const TooltipImage = ({
  src,
  alt = '',
  style,
}: {
  src: string;
  alt?: string;
  style?: CSSProperties;
}): JSX.Element => (
  <Image
    src={src}
    alt={alt}
    // Avoid jumpiness while image loads
    style={{ minHeight: '133px', ...style }}
  />
);
